import { createContext, useContext } from 'react';
import type { RecentCalculation } from './calcSession';

export interface CalcSessionContextValue {
  /** Recents to list under the results banner (newest first, not the one on screen). */
  recents: RecentCalculation[];
  /** Clock for "4 min ago", refreshed while the page is open. */
  now: number;
  /** Reloads a recent's inputs and settings. */
  loadRecent: (recentId: string) => void;
  /** The banner reports what the calculation on screen is, for the label a recent gets. */
  describeCurrent: (label: string, result: string) => void;
}

/** Provided by CalculatorSession; null on pages without idle reset and recents. */
export const CalcSessionContext = createContext<CalcSessionContextValue | null>(null);

export function useCalcSession() {
  return useContext(CalcSessionContext);
}
